import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterFace, DISCOUNT_TYPES, discountSectionsInterface} from "./discounstInterface";
import {setDiscountSections} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import {getPriceWithCurrency} from "../../misc/helpers";

class Discount extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterFace),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  render() {
    const {discount, fabricatorSettings} = this.props;
    const disabled = this.isDiscountDisabled();
    return (
      <li className={"discount" + (disabled ? " discount--disabled" : "")}>
        <div className="discount-cell discount-cell--select">
          <button className={"ui-checkbox" + (discount.selected ? " ui-checkbox--checked" : "")}
                  onClick={this.handleDiscountSelectClick}/>
        </div>
        <div className="discount-cell discount-cell--name" onClick={this.handleDiscountSelectClick}>{discount.name}</div>
        {discount.selected ? (
          <div className="discount-cell discount-cell--amount">
            {discount.type === DISCOUNT_TYPES.price
              ? getPriceWithCurrency(fabricatorSettings, discount.amount)
              : `(${discount.amount}%) \xa0\xa0\xa0\xa0 -${getPriceWithCurrency(fabricatorSettings, this.getDiscountPercentageAmount())}`
            }
          </div>
        ) : null}
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    discountSections: store.priceWorksheetState.discountSections,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorSettings: store.fabricatorState.settings,
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(Discount);
